import styled from 'styled-components'

export const ConversationRichTextStrongStyled = styled.strong`
  font-weight: ${(props) => props.theme.fontWeights.bold};
`
